import React from 'react'
import classNames from 'classnames'

const DropdownHeader = ({ className, children }) => {
    return <div className={classNames('fs-2 c-neutral-300 pb-2 pt-2 px-2', className)}>{children}</div>
}

export default DropdownHeader
